<template>
  <div class="notice-container">
    <custom-router-link :item="info" class="notice-link" :to="{name: 'HomeDetails', params: {id: info.id}}" target="_blank">
      <div class="notice-details">
        <div class="notice-title">{{info.name}}</div>
        <div class="publish-time">{{info.publishTime && info.publishTime.split(" ")[0]}}</div>
      </div>
    </custom-router-link>
  </div>
</template>

<script>
export default {
  data() {
    return {

    }
  },
  props: {
    info: {
      type: Object,
      default: () => { }
    }
  },
  components: {

  },
  mounted() {

  },
  methods: {

  },
}
</script>

<style lang="less" scoped>
.notice-container {
  width: 100%;
  .notice-link {
    width: 100%;
    .notice-details {
      .publish-time {
        color: #efba4c;
        font-size: 13px;
        line-height: 20px;
        position: relative;
        &::after {
          display: block;
          content: "";
          position: absolute;
          right: 0;
          top: 10px;
          width: calc(100% - 90px);
          height: 1px;
          background: #dfe2e5;
        }
      }
      .notice-title {
        font-size: 16px;
        line-height: 32px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
      }
    }
  }
}

@media screen and (max-width: 768px) {
  .notice-container {
    .notice-link {
      .notice-details {
        .publish-time {
          font-size: 12px;
          &::after {
            width: calc(100% - 80px);
          }
        }
        .notice-title {
          font-size: 16px;
          line-height: 26px;
        }
      }
    }
  }
}
</style>